module.exports = __webpack_public_path__ + "static/media/view6.c8043855.jpg";